import { NavMenuItemProps } from '../../atoms/NavMenuItem';


type NavMenuListInternalProps = {
  navMenuItem?: NavMenuItemProps;
};

type NavMenuListPropsValues = {
  'Collapsed': NavMenuListInternalProps;
  'Expanded': NavMenuListInternalProps;
};

const propValues: NavMenuListPropsValues = {
  'Collapsed': {
    navMenuItem: {
      type: 'Icon',
      state: 'Default',
    },
  },
  'Expanded': {
    navMenuItem: {
      type: 'IconText',
      state: 'Default',
    },
  },
};

const getProps = (type: string): NavMenuListInternalProps => {
  const values: NavMenuListInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
